/**
 * 物品视角模板（管理后台）
 *
 * 与角色 / 场景视角列表完全独立：用户在物品详情页生成主图 / 多视角时，
 * 仅从此列表加载选项。
 */

import { directorAdminApi } from '../../../apps/director/services/directorAdminApi';
import { AngleTemplatesEditor } from './AngleTemplatesEditor';

export default function DirectorPropAngleTemplatesTab() {
  return (
    <AngleTemplatesEditor
      title="物品视角模板"
      description={
        '用户在物品详情页生成主图 / 多视角时，会从这里加载可选视角。promptSuffix 会拼到物品描述末尾用于生图。\n仅影响"物品"，与角色 / 场景视角独立。'
      }
      placeholderName="名称（如：主图 / 三视图 / 俯视）"
      placeholderSuffix="prompt 后缀，如 ', isolated product on white background'"
      load={() => directorAdminApi.getPropAngleTemplates()}
      save={(t) => directorAdminApi.updatePropAngleTemplates(t)}
    />
  );
}
